<template>
  <div
    class="w-full border-t border-dashed border-gray-400 hover:bg-gray-100 p-2 grid grid-cols-2 gap-2 gap-y-2"
    :key="index">
    <div>
      <p class="font-bold text-md sm:text-sm mb-2"> {{ $t("Category") }} {{ item.category_name }} </p>
      <div class="w-full flex gap-2 items-baseline">
        <span v-if="item.section" class="text-xs text-secondary uppercase">{{ $t("Section") }} {{ item.section }}</span>
        <span class="flex items-baseline gap-1" v-if="item.row">
          <span class="text-xs text-secondary uppercase">{{ $t("Row") }}</span>
          <span class="font-semibold">{{ item.row }}</span>
        </span>
        <span v-if="item.row && item.seat"> / </span>
        <span class="flex items-baseline gap-1" v-if="item.seat">
          <span class="text-xs text-secondary uppercase">{{ $t("Seat") }}</span>
          <span class="font-semibold">{{ item.seat }}</span>
        </span>
      </div>
    </div>
    <div v-if="!!item.guest && Object.keys(item.guest).length" class="col-start-1">
      <guest :guest="item.guest" />
    </div>
    <div class="ml-auto">
      <div v-if="physicalTickets && allowDownload" class="text-xs">
        {{ $t("This order contains physical tickets. We have sent you an email with more information") }}.
      </div>
      <div v-if="isReturnedorDeleted" class="text-xs"> {{ $t("This ticket has been returned or retrieved") }}. </div>
      <a v-else-if="allowDownload" href="#" class="text-xs sm:text-sm">
        <div
          v-if="
            hasLinks &&
            item.download_items.length === 2 &&
            item.download_items.some((i) => ['ios', 'android'].includes(i.label))
          ">
          <div class="flex flex-col">
            <div class="text-gray-600">
              <strong>{{ $t("Download tickets") }}</strong>
            </div>
            <div class="flex flex-wrap gap-2 justify-start items-center pt-3">
              <div v-for="link in item.download_items" class="flex grow shadow-sm text-center">
                <template v-if="link.external_activation_link">
                  <a
                    v-if="link.label == 'ios' || link.label == 'android'"
                    target="_blank"
                    :href="link.external_activation_link">
                    <img
                      width="115"
                      height="23"
                      :class="link.label == 'ios' ? 'w-32' : 'w-36'"
                      :src="link.label == 'ios' ? appleIcon : googleIcon"
                  /></a>
                  <a
                    v-else
                    class="hover:underline rounded bg-primary py-1 px-2 text-sm font-medium w-full"
                    target="_blank"
                    :href="link.external_activation_link"
                    ><span class="capitalize"> {{ link.label }} </span> {{ $t("App") }}</a
                  >
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="hasLinks" v-for="link in item.download_items">
          <a
            v-if="link.external_activation_link"
            target="_blank"
            :href="link.external_activation_link"
            class="hover:underline px-2 py-1 rounded bg-primary hover:shadow text-sm font-medium flex gap-1 mt-1 items-center"
            >{{ $t("Open ticket") }}</a
          >
        </div>

        <div
          v-else
          @click="downloadSingleTicketInterceptor()"
          class="text-xs sm:text-sm text-xs flex items-center gap-2 ml-auto hover:text-opacity-10 hover:underline">
          Download PDF <DocumentArrowDownIcon class="h-6 float-right" />
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { Guest } from "@/components/xs2ticket";
import { DocumentArrowDownIcon } from "@heroicons/vue/24/solid";
import { useBookingsStore } from "@/store/bookings";
import { TicketStatus } from "@xs2event/js-lib";
import { computed } from "vue";
import appleIcon from "@/assets/images/add_to_apple_wallet.svg";
import googleIcon from "@/assets/images/add_to_google_wallet.svg";

const bookingsStore = useBookingsStore();
const { item, bookingOrderId, index, allowDownload, hasLinks, physicalTickets } = defineProps([
  "item",
  "bookingOrderId",
  "index",
  "allowDownload",
  "hasLinks",
  "physicalTickets",
]);

const downloadSingleTicketInterceptor = () => {
  const payload = {
    bookingorderId: bookingOrderId,
    url: item?.download_link,
    orderItemId: item?.orderitem_id,
    dayIdx: "",
  };
  bookingsStore.downloadSingleTicket(payload).then((res) => {
    if (!!res) {
      URL.revokeObjectURL(res);
    }
  });
};

const isReturnedorDeleted = computed(() => {
  return item.ticket_status === TicketStatus.RETURNED || !!item.deleted;
});
</script>
